import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { CollapseTransition } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import Mixin from './mixin';
export default {
  name: buildComponentName('CollapsePanel'),
  mixins: [Mixin],
  props: {
    name: {
      type: [String, Number],
      default: ''
    },
    header: {
      type: [String, Number],
      default: ''
    },
    headerClass: {
      type: [String, Object, Array],
      default: ''
    },
    showArrow: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    forceRender: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    prefixCls: function prefixCls() {
      var rootPrefixCls = this.rootPrefixCls;
      return rootPrefixCls;
    },
    uid: function uid() {
      var name = this.name,
          _uid = this._uid; // opensource.cnsuning.com/uxcool/lerna-uxcool/issues/261

      return name === 0 ? 0 : name || "$$id_".concat(_uid);
    },
    isActive: function isActive() {
      var rootActiveKeys = this.rootActiveKeys,
          uid = this.uid;
      return rootActiveKeys.indexOf(uid) > -1;
    },
    isDestroyInactive: function isDestroyInactive() {
      var forceRender = this.forceRender,
          rootDestroyInactivePanel = this.rootDestroyInactivePanel;
      return !forceRender && rootDestroyInactivePanel;
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          isActive = this.isActive,
          disabled = this.disabled,
          showArrow = this.showArrow;
      var itemCls = "".concat(prefixCls, "-item");
      return _ref = {}, _defineProperty(_ref, itemCls, true), _defineProperty(_ref, "".concat(itemCls, "-active"), isActive), _defineProperty(_ref, "".concat(itemCls, "-disabled"), disabled), _defineProperty(_ref, "".concat(prefixCls, "-no-arrow"), !showArrow), _ref;
    }
  },
  methods: {
    onHeaderClick: function onHeaderClick(e) {
      var disabled = this.disabled,
          onRootHeaderClick = this.onRootHeaderClick;
      e.stopPropagation();
      e.preventDefault();

      if (disabled) {
        return;
      }

      onRootHeaderClick(this.uid, e);
    },
    onHeaderKeyPress: function onHeaderKeyPress(e) {
      var keyCode = e.keyCode;

      if (keyCode === 13) {
        this.onHeaderClick(e);
      }
    },
    renderHeader: function renderHeader() {
      var h = this.$createElement;
      var $slots = this.$slots,
          prefixCls = this.prefixCls,
          rootAccordion = this.rootAccordion,
          header = this.header,
          headerClass = this.headerClass,
          showArrow = this.showArrow,
          disabled = this.disabled,
          isActive = this.isActive,
          onHeaderClick = this.onHeaderClick,
          onHeaderKeyPress = this.onHeaderKeyPress;
      var attrs = {
        role: rootAccordion ? 'tab' : 'button',
        tabindex: disabled ? -1 : 0,
        'aria-expanded': isActive
      };
      var on = {
        click: onHeaderClick,
        keypress: onHeaderKeyPress
      };
      return h("div", _mergeJSXProps([{}, {
        class: ["".concat(prefixCls, "-header"), headerClass],
        attrs: attrs,
        on: on
      }]), [showArrow ? h("i", {
        "class": "arrow"
      }) : null, $slots.header || header]);
    },
    renderChildren: function renderChildren() {
      var _cls;

      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          $slots = this.$slots,
          rootAccordion = this.rootAccordion,
          isDestroyInactive = this.isDestroyInactive,
          isActive = this.isActive;
      var cls = (_cls = {}, _defineProperty(_cls, "".concat(prefixCls, "-content"), true), _defineProperty(_cls, "".concat(prefixCls, "-content-active"), isActive), _defineProperty(_cls, "".concat(prefixCls, "-content-inactive"), !isActive), _cls);
      var role = rootAccordion ? 'tabpanel' : null;
      var children = null;

      if (isDestroyInactive) {
        children = isActive ? h("div", {
          "attrs": {
            "role": role
          },
          "class": cls
        }, [h("div", {
          "class": "".concat(prefixCls, "-content-box")
        }, [$slots.default])]) : null;
      } else {
        children = h("div", {
          "attrs": {
            "role": role
          },
          "class": cls,
          "directives": [{
            name: "show",
            value: isActive
          }]
        }, [h("div", {
          "class": "".concat(prefixCls, "-content-box")
        }, [$slots.default])]);
      }

      return h(CollapseTransition, [children]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var classes = this.classes,
        renderHeader = this.renderHeader,
        renderChildren = this.renderChildren;
    return h("div", {
      "class": classes
    }, [renderHeader(), renderChildren()]);
  }
};